import { Link } from 'react-router-dom';
import type { ModuleId } from '../core/types';

const moduleCopy: Record<ModuleId, { number: string; title: string; description: string; aim: string }> = {
  'read-switch': {
    number: '1',
    title: 'ぼやけた波の変化を見分ける',
    description: 'ドット面に短く現れる2つの波が、内向きか外向きかを答えます。',
    aim: '見分けられる表示時間を記録',
  },
  'central-peripheral': {
    number: '2',
    title: '車と周辺標識を同時に見る',
    description: '中央の車種と、周辺に現れた標識の位置を一度に覚えて答えます。',
    aim: '2つを同時に読み取れる表示時間を記録',
  },
  'player-track': {
    number: '3',
    title: '動く4個を同時に追う',
    description: '同じ見た目の8個が動く中で、最初に表示された4個を追い続けます。',
    aim: '4個を追い続けられる動きの速さを記録',
  },
  'moving-target': {
    number: '4',
    title: '動く記号の向きを見分ける',
    description: '画面を動く輪の切れ目が、上下左右のどちらを向いているか答えます。',
    aim: '見分けられる最小の大きさを記録',
  },
};

export function ModuleCard({ id, href }: { id: ModuleId; href?: string }) {
  const item = moduleCopy[id];
  return (
    <article className="module-card">
      <div className="module-number" aria-hidden="true">{item.number}</div>
      <h3>{item.title}</h3>
      <p>{item.description}</p>
      <footer>
        <span>{item.aim}</span>
        {href && <Link className="module-start-link" to={href} aria-label={`${item.title}だけを練習`}>この課題だけ練習 →</Link>}
      </footer>
    </article>
  );
}
